export default "<div (click)=\"showHide()\">\n  <ng-content></ng-content>\n</div>\n"